/**
 * Istanzia lo store
 * @module store/index
*/

import Vue from 'vue'
import Vuex from 'vuex'
import { state } from '@/store/state'
import * as getters from '@/store/getters'
import * as actions from '@/store/actions'
import * as mutations from '@/store/mutations'
import plugins from '@/store/plugins'

Vue.use(Vuex)

const store = new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  plugins
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js